<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { pluralContainerType } from "@shared/services/product.js";
  import { capitalize } from "lodash";

  export let containerType: string;
  export let selectContainerType: (container: string) => void;
  export let isSelected: boolean;

  const containerTypeIcon = (container: string): string => {
    if (container === "package" || container === "item") return "Box";
    if (container === "recentlyOrdered") return "Clock";
    if (container === "deals") return "Deal";
    if (container != "other") return capitalize(container);
    return "Question";
  };

  const select = (_e: Event): void => {
    selectContainerType(containerType);
  };

  $: type = containerTypeIcon(containerType);

</script>

<li class="list-item capitalize" class:product-detail__deals-tab={containerType === "deals"}>
  <div
    data-testid={`container-type-${containerType}${isSelected ? "-selected" : ""}`}
    class="product-detail__product-tabs-tab cursor-pointer tabs__tab-background container-type-tab"
    class:tabs__tab-background--active={isSelected}
    on:click={select}
    on:keypress={select}
  >
    <Icon centered={true} extraClassNames="product-detail__product-tabs-icon" {type} />
    {#if containerType === "recentlyOrdered"}
      recent
    {:else if containerType === "deals"}
      deals
    {:else}
      {pluralContainerType(containerType)}
    {/if}
  </div>
</li>
